import { useEffect, useState, type ReactNode } from "react";

import { cn } from "@/lib/utils";

export function FocusedEditorShell({
  children,
  modal = false,
}: {
  children: ReactNode;
  modal?: boolean;
}) {
  const [isVisible, setIsVisible] = useState(!modal);

  useEffect(() => {
    if (!modal) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => setIsVisible(true));
    return () => window.cancelAnimationFrame(frameId);
  }, [modal]);

  if (!modal) {
    return <div className="min-h-screen bg-background">{children}</div>;
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/18 backdrop-blur-[2px]">
      <div
        className={cn(
          "absolute inset-0 w-full overflow-hidden bg-background shadow-[0_24px_80px_rgba(15,15,16,0.24)] transition-[transform,opacity] duration-300 ease-out",
          isVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0",
        )}
      >
        {children}
      </div>
    </div>
  );
}
